/** Stable `data-guide` values. Templates use these same strings. */
export const GUIDE = {
  heading: 'page-heading',
  actions: 'page-actions',
  filters: 'page-filters',
  table: 'main-table',
  detail: 'detail-main',
  kpi: 'kpi-cards',
  kpiChart: 'kpi-chart',
  gantt: 'gantt-chart',
  finance: 'finance-summary',
  mapTools: 'map-tools',
  mapDrawing: 'map-drawing',
  mapObjects: 'map-objects',
  mapLinks: 'map-links',
  mapCanvas: 'map-canvas',
  mapLegend: 'map-legend',
  mapLineRoute: 'map-line-route',
  mapLinePhase: 'map-line-phase',
  mapVykopConfirm: 'map-vykop-confirm',
  mapVykopDraw: 'map-vykop-draw',
  mapRouteChoose: 'map-route-choose',
  mapRouteNew: 'map-route-new',
  mapRouteConfirm: 'map-route-confirm',
  mapRouteCancel: 'map-route-cancel',
  mapPointType: 'map-point-type',
  mapPointMilestones: 'map-point-milestones',
  mapPointSpec: 'map-point-spec',
  mapRozvadecMilestones: 'map-rozvadec-milestones',
  mapRozvadecSpec: 'map-rozvadec-spec',
  mapPopupHeader: 'map-popup-header',
  mapBtnDelete: 'map-btn-delete',
  mapBtnMove: 'map-btn-move',
  mapBtnRename: 'map-btn-rename',
  mapBtnInfo: 'map-btn-info',
  mapBtnClose: 'map-btn-close',
  mapBtnPhotos: 'map-btn-photos',
  mapBtnMaterial: 'map-btn-material',
  mapBtnNote: 'map-btn-note',
  mapBtnShare: 'map-btn-share',
  mapBtnSurfaces: 'map-btn-surfaces',
  mapBtnWelds: 'map-btn-welds',
  mapBtnSpec: 'map-btn-spec',
  mapPopupActions: 'map-popup-actions',
  mapPopupPhases: 'map-popup-phases',
  mapPopupAcq: 'map-popup-acq',
  calendar: 'calendar-board',
  calendarPeople: 'calendar-people',
  invoiceSummary: 'invoice-summary',
  dashChart: 'dash-chart',
  mailFolders: 'mail-folders',
  settingsConnections: 'settings-connections',
  settingsTheme: 'settings-theme',
  settingsSidebar: 'settings-sidebar',
  dbTables: 'db-tables',
  listSearch: 'list-search',
  listExport: 'list-export',
  listPages: 'list-pages',
  dashPolygon: 'dash-polygon',
  dashBranch: 'dash-branch',
  ganttYear: 'gantt-year',
  ganttBranch: 'gantt-branch',
  ganttType: 'gantt-type',
  ganttStatus: 'gantt-status',
  ganttToday: 'gantt-today',
  financeDate: 'finance-date',
  financePolygon: 'finance-polygon',
  financeStatus: 'finance-status',
  financePlan: 'finance-plan',
  invoicePay: 'invoice-pay',
  invoiceRevert: 'invoice-revert',
  invoiceDelete: 'invoice-delete',
  invoiceRow: 'invoice-row',
  userEdit: 'user-edit',
  userPermissions: 'user-permissions',
  usersStatus: 'users-status',
  usersBranch: 'users-branch',
  objectMap: 'object-map',
  objectPhase: 'object-phase',
  objectSpec: 'object-spec',
  objectPhotos: 'object-photos',
  wrAdd: 'wr-add',
  wrDates: 'wr-dates',
  wrUser: 'wr-user',
  wrPayment: 'wr-payment',
  wrSelect: 'wr-select',
  wrRow: 'wr-row',
  wrBilling: 'wr-billing',
  wrMode: 'wr-mode',
  whReceipt: 'wh-receipt',
  whIssue: 'wh-issue',
  whUpload: 'wh-upload',
} as const;

export interface PageGuideStep {
  /** Value of the `data-guide` attribute on the real control. */
  target: string;
  title: string;
  body: string;
}

export interface PageGuideSession {
  steps: readonly PageGuideStep[];
  index: number;
}
